import React from 'react';
import { Link } from 'react-router-dom';
import Sales from '../Widgets/Sales';

export default () => (
    <div id="statistics-business">
        <header className="content-header">
            <h1>
                Statistics
                <small>Business</small>
            </h1>
            <ol className="breadcrumb">
                <li><i className="fa fa-bar-chart"/> Statistics</li>
                <li className="text-bold"><Link to="/statistics/business">Business</Link></li>
            </ol>
        </header>
        <section className="content">
            <Sales />
        </section>
    </div>
);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Business/index.js